module.exports = __webpack_public_path__ + "img/default-slider.b212a9c.jpg";